import React, { useState, useEffect } from 'react';
import authService from '../../api-authorization/AuthorizeService';
import axios from 'axios';
import "bootstrap/dist/css/bootstrap.min.css"; //https://www.creative-tim.com/blog/web-design/how-to-use-bootstrap-with-reactjs/
import createCache from '@emotion/cache';
import LoadingButton from '@mui/lab/LoadingButton';
import { Link, useLocation } from 'react-router-dom'
import queryString from 'query-string'
import { trackPromise } from 'react-promise-tracker';
import { usePromiseTracker } from "react-promise-tracker";
import { Switch, Checkbox, Button, TextField, Modal, Box, Grid, Stack, Typography, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormGroup, FormControl, FormLabel, FormControlLabel, Accordion, AccordionSummary, AccordionDetails } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Moment from 'moment';
import { Bars, MagnifyingGlass } from "react-loader-spinner";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import MenuItem from '@mui/material/MenuItem';
import FindPlayers from '../../FindPlayers';


export default function TagPlayerGames(props) {
    const [selectedPlayer, setSelectedPlayer] = useState({});
    const [playerId, setPlayerId] = useState();
    const [idType, setIdType] = useState("FIDE");

    const { search } = useLocation()
    const values = queryString.parse(search)

    const [lastName, setLastName] = useState("");
    const [firstName, setFirstName] = useState("");
    const [exactMatchLastName, setExactMatchLastName] = useState(true);
    const [exactMatchFirstName, setExactMatchFirstName] = useState(false);
    
    const [playerUSCFID, setPlayerUSCFID] = useState(-1);
    const [playerFIDEID, setPlayerFIDEID] = useState(-1);
    const [newPlayerUSCFID, setNewPlayerUSCFID] = useState(-1);
    const [newPlayerFIDEID, setNewPlayerFIDEID] = useState(-1);
    const [newPlayerName, setNewPlayerName] = useState("");

    const [status, setStatus] = useState("");
    const [eventName, setEventName] = useState(props.eventName ? props.eventName : (values.eventName ? values.eventName : "" ));
    const [gameSource, setGameSource] = useState(props.gameSource ? props.gameSource : (values.gameSource ? values.gameSource : ""));
    const [exactMatchEventName, setExactMatchEventName] = useState(props.exactMatchEventName === undefined ? (values.exactMatchEventName === undefined ? false : values.exactMatchEventName) : props.exactMatchEventName);
    var today = Moment().add(1, 'days').format("YYYY-MM-DD");
    var lastMonth = Moment().add(-1, 'months').format("YYYY-MM-DD");
    const [eventStartDate, setEventStartDate] = useState(props.eventStartDate ? props.eventStartDate : (values.eventStartDate ? values.eventStartDate : lastMonth));
    const [eventEndDate, setEventEndDate] = useState(props.eventEndDate ? props.eventEndDate : (values.eventEndDate ? values.eventEndDate : today) );
    const [uscfEventId, setUscfEventId] = useState(-1);
    const [fideEventId, setFideEventId] = useState(-1);
    const [newEventName, setNewEventName] = useState("");
    const [newUSCFEventId, setNewUSCFEventId] = useState(-1);
    const [newFIDEEventId, setNewFIDEEventId] = useState(-1);
    

    const { promiseInProgress } = usePromiseTracker();
    const [statusColor, setStatusColor] = useState();
    const [token, setToken] = useState();
    const [authenticated, setAuthenticated] = useState(false);
    const [games, setGames] = useState([]);
    const [eventGames, setEventGames] = useState([]);
    const [downloading, setDownloading] = useState(false);
    const [waiting, setWaiting] = useState(false);
    const [searching, setSearching] = useState(false);
    const [blankDate, setBlankDate] = useState("");
    const [overrideMembershipLevel, setOverrideMembershipLevel] = useState(false);
    const [membershipLevel, setMembershipLevel] = useState(0);
    const [newUSCFPlayerId, setNewUSCFPlayerId] = useState(-1);
    const [newFIDEPlayerId, setNewFIDEPlayerId] = useState(-1);
    const [newCFCPlayerId, setNewCFCPlayerId] = useState(-1);
    const [playerColor, setPlayerColor] = useState("White");

    const centerDivStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '20vh'
    }; //https://www.c-sharpcorner.com/blogs/how-to-make-a-div-center-in-screen-in-react-js

    useEffect(() => {
        async function fetchData() {
            setAuthenticated(await authService.isAuthenticated());
            var ttt = await authService.getAccessToken();
            await setToken(ttt);

        };
        fetchData();
            
    }, []);

    const updateSelectedPlayers = async (player) => {
        setSelectedPlayer(player);
        if (player) {
            var name = player.fideName ? player.fideName : player.uscfName;
            setNewPlayerName(name);
            setLastName(name.split(",")[0]);
            setFirstName(name.split(",")[1]);
            setPlayerUSCFID(player.uscfPlayerId);
            setPlayerFIDEID(player.fidePlayerId);
            setNewPlayerUSCFID(player.uscfPlayerId);
            setNewPlayerFIDEID(player.fidePlayerId);
            if (player.fideBirthday) {
                var today = Moment().add(1, 'days').format("YYYY-MM-DD");
                setEventStartDate(player.fideBirthday+"-01-01");
                setEventEndDate(today);
            }
        }
         
    };


    const findPlayerGames = async () => {
        //e.preventDefault();
        var t = await authService.getAccessToken();
        var headers = {
            headers: { 'Authorization': `Bearer ${t}` }
        }
        trackPromise(
            axios.get('/api/chessgames/GetPlayerGames?eventName=' + eventName
                + '&eventStartDate=' + eventStartDate
                + '&eventEndDate=' + eventEndDate
                + '&exactMatchEventName=' + exactMatchEventName
                + '&gameSource=' + gameSource
                + '&playerColor=' + playerColor
                + '&lastName=' + lastName
                + '&firstName=' + firstName
                + '&exactMatchLastName=' + exactMatchLastName
                + '&exactMatchFirstName=' + exactMatchFirstName,
                headers)
                .then((response) => {
                let playergames = response.data;
                setEventGames(playergames);
                setGames(playergames);
                setDownloading(false);
                if (playergames.length > 0) {
                    setStatusColor("green");
                    setStatus(playergames.length + " Games found.");
                } else {
                    setStatusColor("red");
                    setStatus("No games found");
                }
                    
            }).catch((error) => {
                setDownloading(false);
                setStatusColor("red");
                setStatus(error.response.data);
                console.log(error.response.data);
            })
        )
        
    };

    const updatePlayerGames = async () => {
        //e.preventDefault();
        var t = await authService.getAccessToken();
        var headers = {
            headers: { 'Authorization': `Bearer ${t}` }
        }

        trackPromise(
            axios.patch('/api/chessgames/UpdatePlayerGames?eventName=' + eventName
                + '&eventStartDate=' + eventStartDate
                + '&eventEndDate=' + eventEndDate
                + '&exactMatchEventName=' + exactMatchEventName
                + '&gameSource=' + gameSource
                + '&playerColor=' + playerColor
                + '&lastName=' + lastName
                + '&firstName=' + firstName
                + '&exactMatchLastName=' + exactMatchLastName
                + '&exactMatchFirstName=' + exactMatchFirstName
                + '&newPlayerName=' + newPlayerName
                + '&membershipLevel=' + membershipLevel
                + '&overrideMembershipLevel=' + overrideMembershipLevel
                + '&newPlayerUSCFID=' + newPlayerUSCFID
                + '&newPlayerFIDEID=' + newPlayerFIDEID,
                null,
                headers)
                .then((response) => {
                let playergames = response.data;
                setEventGames(playergames);
                setGames(playergames);
                setDownloading(false);
                if (playergames.length > 0) {
                    setStatusColor("green");
                    setStatus(playergames.length + " Games found.");
                } else {
                    setStatusColor("red");
                    setStatus("No games found");
                }

            }).catch((error) => {
                setDownloading(false);
                setStatusColor("red");
                setStatus(error.response.data);
                console.log(error.response.data);
            })
        )

    };

    return (

        <div>
            <Accordion m={2} pt={3} pl={3} pr={3} defaultExpanded={true}>
                <AccordionSummary aria-controls="event-info" id="event-info" expandIcon={<ExpandMoreIcon />} sx={{ backgroundColor: '#1976d2'}}>
                    <Typography color='white'>Tag Player Games</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Grid container direction="row" rowSpacing={1} columnSpacing={1} justify-content="space-between" align-items="stretch">
                        <Grid item xs={12} lg={12}>
                            <Stack>
                                <FindPlayers sendToParentIdType={setIdType} sendToParentPlayerId={setPlayerId} sendToParentSelectedPlayer={updateSelectedPlayers} />
                            </Stack>
                        </Grid>
                        {/*<Grid item xs={12} lg={12}>*/}
                        {/*    <Stack>*/}
                        {/*        <span>{JSON.stringify(selectedPlayer)}</span>*/}
                        {/*    </Stack>*/}
                        {/*</Grid>*/}
                        <Grid item xs={6} lg={2}>
                            <Stack>
                                <TextField
                                    fullwidth
                                    size="small"
                                    value={playerColor}
                                    //key={membershipLevel}
                                    defaultValue={playerColor}
                                    //defaultValue={'VIP'}
                                    onChange={async (e) => { setPlayerColor(e.target.value) }}
                                    select
                                    label="Player Color"
                                >
                                    <MenuItem key={0} value={"White"}>White</MenuItem>
                                    <MenuItem key={1} value={"Black"}>Black</MenuItem>
                                </TextField>
                            </Stack>
                        </Grid>
                        <Grid item xs={6} lg={2}>
                            <Stack>
                                <TextField
                                    required
                                    fullwidth="true"
                                    size="small"
                                    label={exactMatchLastName ? 'Last Name Is ' : 'Last Name Starts With'}
                                    InputLabelProps={{ shrink: true, }}
                                    variant='outlined'
                                    value={lastName}
                                    onChange={async (e) => { setLastName(e.target.value) }}
                                />
                            </Stack>
                        </Grid>
                        <Grid item xs={6} lg={1}>
                            <Stack>
                                <FormControlLabel fullwidth="true" control={<Switch checked={exactMatchLastName} onChange={async (e) => { setExactMatchLastName(e.target.checked) }} />} label={exactMatchLastName? "Is":"Like"} />
                            </Stack>
                        </Grid>
                        <Grid item xs={6} lg={2}>
                            <Stack>
                                <TextField
                                    required
                                    fullwidth="true"
                                    size="small"
                                    label={exactMatchFirstName ? 'First Name Is ' : 'First Name Starts With'}
                                    InputLabelProps={{ shrink: true, }}
                                    variant='outlined'
                                    value={firstName}
                                    onChange={async (e) => { setFirstName(e.target.value) }}
                                />
                            </Stack>
                        </Grid>
                        <Grid item xs={6} lg={1}>
                            <Stack>
                                <FormControlLabel fullwidth="true" control={<Switch checked={exactMatchFirstName} onChange={async (e) => { setExactMatchFirstName(e.target.checked) }} />} label={exactMatchFirstName ? "Is" : "Like"} />
                            </Stack>
                        </Grid>
                        <Grid item xs={6} lg={2}>
                            <Stack>
                                <TextField
                                    required
                                    fullwidth="true"
                                    size="small"
                                    label={playerUSCFID > -1 ? <a href={'http://www.uschess.org/msa/MbrDtlTnmtHst.php?' + playerUSCFID} target='_blank' rel='noreferrer'>{'USCF ID ' + playerUSCFID}</a> : 'USCF ID'}
                                    InputLabelProps={{ shrink: true, }}
                                    variant='outlined'
                                    value={playerUSCFID}
                                    inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                                    onChange={async (e) => { setPlayerUSCFID(e.target.value ? e.target.value : -1) }}
                                />
                            </Stack>
                        </Grid>
                        <Grid item xs={6} lg={2}>
                            <Stack>
                                <TextField
                                    required
                                    fullwidth="true"
                                    size="small"
                                    label={playerFIDEID > -1 ? <a href={'https://ratings.fide.com/profile/' + playerFIDEID} target='_blank' rel='noreferrer'>{'FIDE ID ' + playerFIDEID}</a> : 'FIDE ID'}
                                    InputLabelProps={{ shrink: true, }}
                                    variant='outlined'
                                    value={playerFIDEID}
                                    inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                                    onChange={async (e) => { setPlayerFIDEID(e.target.value ? e.target.value : -1) }}
                                />
                            </Stack>
                        </Grid>
                        {/*<Grid item xs={12} lg={12}>*/}
                        {/*    <Stack>*/}
                        {/*        <span>{'Search Criteria : '+*/}
                        {/*            (eventName ? 'Event Name ' : '') + (eventName && (exactMatchEventName ? " is " : "starts with ")) + (eventName ? eventName : '') + (gameSource ? ' Game Source is ' + gameSource : '') + (eventStartDate ? ' Starts on ' + eventStartDate : '') + (eventEndDate ? " Ends on " + eventEndDate : '')}*/}
                        {/*            <span style={{ color: statusColor }}>{status ? ' ' + status : ''}</span>*/}
                        {/*        </span>*/}
                        {/*    </Stack>*/}
                        {/*</Grid>*/}
                        <Grid item xs={6} lg={3}>
                            <Stack>
                                <TextField
                                    required
                                    fullwidth="true"
                                    size="small"
                                    label={exactMatchEventName ? 'Event Name Is ' : 'Event Name Starts With'}
                                    InputLabelProps={{ shrink: true, }}
                                    variant='outlined'
                                    value={eventName}
                                    onChange={async (e) => { setEventName(e.target.value) }}
                                />
                            </Stack>
                        </Grid>
                        <Grid item xs={6} lg={2}>
                            <Stack>
                                <FormControlLabel fullwidth="true" control={<Switch checked={exactMatchEventName} onChange={async (e) => {setExactMatchEventName(e.target.checked) }} />} label="Exact Match" />
                            </Stack>
                        </Grid>
                        <Grid item xs={6} lg={2}>
                            <Stack>
                                <TextField
                                    fullwidth="true"
                                    size="small"
                                    label={'Game Source'}
                                    InputLabelProps={{ shrink: true, }}
                                    variant='outlined'
                                    value={gameSource}
                                    onChange={async (e) => { setGameSource(e.target.value) }}
                                />
                            </Stack>
                        </Grid>
                        <Grid item xs={6} lg={2}>
                            <Stack>
                                <TextField
                                    required
                                    fullwidth="true"
                                    size="small"
                                    label='Start Date'
                                    InputLabelProps={{ shrink: true, }}
                                    variant='outlined'
                                    type='date'
                                    value={eventStartDate}
                                    onChange={async (e) => { setEventStartDate(e.target.value) }}
                                    error={!eventStartDate}
                                    helperText={!eventStartDate ? 'Required' : ''}
                                    defaultValue={eventStartDate}
                                />
                            </Stack>
                        </Grid>
                        <Grid item xs={6} lg={2}>
                            <Stack>
                                <TextField
                                    required
                                    fullwidth="true"
                                    size="small"
                                    label='End Date'
                                    InputLabelProps={{ shrink: true, }}
                                    variant='outlined'
                                    type='date'
                                    value={eventEndDate}
                                    onChange={async (e) => { setEventEndDate(e.target.value) }}
                                    error={!eventEndDate}
                                    helperText={!eventEndDate ? 'Required' : ''}
                                    defaultValue={eventEndDate}
                                />
                            </Stack>
                        </Grid>
                        <Grid item xs={12} lg={1}>
                            <Stack>
                                <LoadingButton
                                    onClick={async (e) => { await setDownloading(true); await findPlayerGames(); }}
                                    loading={downloading}
                                    disabled={!lastName || !firstName}
                                    loadingIndicator="Wait"
                                    variant="contained"
                                    color="primary"
                                >
                                    Search
                                </LoadingButton>
                            </Stack>
                        </Grid>

                    </Grid>
                </AccordionDetails>
                <AccordionDetails>
                    {/*games.length > 0 &&*/
                        <Grid container direction="row" rowSpacing={1} columnSpacing={1} justify-content="space-between" align-items="stretch">
                            <Grid item xs={6} lg={3}>
                                <Stack>
                                    <TextField
                                        required
                                        fullwidth="true"
                                        size="small"
                                        label={'New Player Name'}
                                        InputLabelProps={{ shrink: true, }}
                                        variant='outlined'
                                        value={newPlayerName}
                                        onChange={async (e) => { setNewPlayerName(e.target.value) }}
                                    />
                                </Stack>
                            </Grid>
                            <Grid item xs={6} lg={2}>
                                <Stack>
                                    <TextField
                                        fullwidth
                                        size="small"
                                        value={membershipLevel}
                                        key={membershipLevel}
                                        defaultValue={membershipLevel}
                                        disabled={!overrideMembershipLevel}
                                        //defaultValue={'VIP'}
                                        onChange={async (e) => { setMembershipLevel(e.target.value) }}
                                        select
                                        label="Access Level"
                                    >
                                        <MenuItem key={0} value={0}>0 - Basic</MenuItem>
                                        <MenuItem key={1} value={1}>1 - Bronze</MenuItem>
                                        <MenuItem key={2} value={2}>2 - Silver</MenuItem>
                                        <MenuItem key={3} value={3}>3 - Gold</MenuItem>
                                        <MenuItem key={4} value={4}>4 - Diamond</MenuItem>
                                        <MenuItem key={5} value={5}>5 - L5</MenuItem>
                                        <MenuItem key={6} value={6}>6 - L6</MenuItem>
                                        <MenuItem key={7} value={7}>7 - L7</MenuItem>
                                        <MenuItem key={8} value={8}>8 - L8</MenuItem>
                                        <MenuItem key={9} value={9}>9 - VIP</MenuItem>
                                    </TextField>
                                </Stack>
                            </Grid>
                            <Grid item xs={6} lg={2}>
                                <Stack>
                                    <FormControlLabel fullwidth="true" control={<Checkbox checked={overrideMembershipLevel} onChange={async (e) => { setOverrideMembershipLevel(e.target.checked) }} />} label={"Override"} />
                                </Stack>
                            </Grid>
                            <Grid item xs={6} lg={2}>
                                <Stack>
                                    <TextField
                                        required
                                        fullwidth="true"
                                        size="small"
                                        label={newPlayerUSCFID > -1 ? <a href={'http://www.uschess.org/msa/MbrDtlTnmtHst.php?' + newPlayerUSCFID} target='_blank' rel='noreferrer'>{'New USCF ID ' + newPlayerUSCFID}</a> : ' New USCF ID'}
                                        InputLabelProps={{ shrink: true, }}
                                        variant='outlined'
                                        value={newPlayerUSCFID}
                                        inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                                        onChange={async (e) => { setNewPlayerUSCFID(e.target.value ? e.target.value : -1) }}
                                    />
                                </Stack>
                            </Grid>
                            <Grid item xs={6} lg={2}>
                                <Stack>
                                    <TextField
                                        required
                                        fullwidth="true"
                                        size="small"
                                        label={newPlayerFIDEID > -1 ? <a href={'https://ratings.fide.com/profile/' + newPlayerFIDEID} target='_blank' rel='noreferrer'>{'New FIDE ID ' + newPlayerFIDEID}</a> : 'New FIDE ID'}
                                        InputLabelProps={{ shrink: true, }}
                                        variant='outlined'
                                        value={newPlayerFIDEID}
                                        inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                                        onChange={async (e) => { setNewPlayerFIDEID(e.target.value ? e.target.value : -1) }}
                                    />
                                </Stack>
                            </Grid>
                            <Grid item xs={12} lg={1}>
                                <Stack>
                                    <LoadingButton
                                        onClick={async (e) => { await setDownloading(true); await updatePlayerGames(); }}
                                        loading={downloading}
                                        disabled={!lastName || !firstName || !eventStartDate || !eventEndDate || !newPlayerName || !newPlayerFIDEID || !newPlayerUSCFID || !(games.length > 0)}
                                        loadingIndicator="Wait"
                                        variant="contained"
                                        color="primary"
                                    >
                                        Update
                                    </LoadingButton>
                                </Stack>
                            </Grid>

                        </Grid>
                    }
                </AccordionDetails>
                <AccordionDetails>
                        {(promiseInProgress === true) ?
                            <div>
                                <Box sx={{ pt: 2, pb: 1 }}>
                                    <div style={centerDivStyle}>
                                        <MagnifyingGlass ariaLabel="Loading" color="#00BFFF" />
                                    </div>
                                </Box>
                            </div>
                            :
                            <div>
                                {games.length > 0 &&
                                    <div>
                                        <TableContainer component={Paper}>
                                            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell align="left">Level</TableCell>
                                                        <TableCell align="left">Date</TableCell>
                                                        <TableCell align="left">Event</TableCell>
                                                        {playerColor === "White" &&
                                                            <TableCell align="left">USCF ID</TableCell>
                                                        }
                                                        {playerColor === "White" &&
                                                            <TableCell align="left">FIDE ID</TableCell>
                                                        }
                                                        <TableCell align="left">White</TableCell>
                                                        <TableCell align="left">Elo</TableCell>
                                                        <TableCell align="left">Result</TableCell>
                                                        <TableCell align="left">Elo</TableCell>
                                                        <TableCell align="left">Black</TableCell>
                                                        {playerColor === "Black" && 
                                                            <TableCell align="left">USCF ID</TableCell>
                                                        }
                                                        {playerColor === "Black" &&
                                                            <TableCell align="left">FIDE ID</TableCell>
                                                        }
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {games.map((game) => (
                                                        <TableRow
                                                            key={game.gameHash}
                                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                        >
                                                            <TableCell component="th" scope="row"><span>{game.membershipLevel}</span></TableCell>
                                                            <TableCell component="th" scope="row"><span>{game.date}</span></TableCell>
                                                            <TableCell align="right">{game.fideEventId > 0 ? <a target="_blank" href={"https://ratings.fide.com/view_games.phtml?event=" + game.fideEventId} >{game.event}</a> : game.event}</TableCell>
                                                            {playerColor === "White" &&
                                                                <TableCell align="right">{game.whiteUSCFID > 0 ? <a target="_blank" href={"https://ratings.uschess.org/player/" + game.whiteUSCFID} >{game.whiteUSCFID}</a> : game.whiteUSCFID}</TableCell>
                                                            }
                                                            {playerColor === "White" &&
                                                                <TableCell align="right">{game.whiteFIDEID > 0 ? <a target="_blank" href={"https://ratings.fide.com/profile/" + game.whiteFIDEID + "/calculations"} >{game.whiteFIDEID}</a> : game.whiteFIDEID}</TableCell>
                                                            }
                                                            <TableCell align="right">{game.whiteFIDEID > 0 ? <a target="_blank" href={"https://ratings.fide.com/profile/" + game.whiteFIDEID + "/calculations"} >{game.white}</a> : game.white}</TableCell>
                                                            <TableCell align="right">{game.whiteUSCFID > 0 ? <a target="_blank" href={"https://ratings.uschess.org/player/" + game.whiteUSCFID} >{game.whiteElo}</a> : game.whiteElo}</TableCell>
                                                            <TableCell align="right">{<Link target="_blank" to={'/games/GameByID/' + game.gameHash}>{game.result}</Link>} </TableCell>
                                                            <TableCell align="right">{game.blackUSCFID > 0 ? <a target="_blank" href={"https://ratings.uschess.org/player/" + game.blackUSCFID} >{game.blackElo}</a> : game.blackElo}</TableCell>
                                                            <TableCell align="right">{game.blackFIDEID > 0 ? <a target="_blank" href={"https://ratings.fide.com/profile/" + game.blackFIDEID + "/calculations"} >{game.black}</a> : game.black}</TableCell>
                                                            {playerColor === "Black" &&
                                                                <TableCell align="right">{game.blackUSCFID > 0 ? <a target="_blank" href={"https://ratings.uschess.org/player/" + game.blackUSCFID} >{game.blackUSCFID}</a> : game.blackUSCFID}</TableCell>
                                                            }
                                                            {playerColor === "Black" &&
                                                                <TableCell align="right">{game.blackFIDEID > 0 ? <a target="_blank" href={"https://ratings.fide.com/profile/" + game.blackFIDEID + "/calculations"} >{game.blackFIDEID}</a> : game.blackFIDEID}</TableCell>
                                                            }
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div>
                                }
                            </div>

                        }
                </AccordionDetails>
            </Accordion>
        </div>

    )
}
